import Button from "components/common/Button";
import Basictabs from "components/common/Tabs";
import Typography from "components/common/Typography";
import {
  fetchMetricsList,
  resetMetricsPlansIds,
  setSelectedTab,
  setSuggestedPlanList
} from "components/features/dashboard/HotelUserDashboard.slice";
import { getHotelUserDashboardInncode } from "components/features/dashboard/HotelUserDashboardHelper";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { tokens } from "styles/Tokens";
import { routes } from "utils/routes";
import "./index.scss";
import { useTabDetails } from "./TabsConfig";

export default function SuggestedPlans() {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const metricsList = useAppSelector((state) => state.hotelUserDashboardSlice.metricsList);
  const innCode = getHotelUserDashboardInncode();
  const currentTab = useAppSelector((state) => state.hotelUserDashboardSlice.selectedTabs["suggestedPlans"]);
  const isAboveProperty = useAppSelector((state) => state.app.loggedInUserDetails.isAbovePropertyUser);

  useEffect(() => {
    if (innCode)
      dispatch(
        fetchMetricsList({
          innCode
        })
      );
    dispatch(setSelectedTab({ page: "suggestedPlans", val: 0 }));
  }, [innCode]);

  const redirectToSuggestedPlans = () => {
    navigate(routes.Library, {
      state: {
        showSeeAll: true,
        showAllPlans: false
      }
    });
  };

  const getSelectedTab = (val: number) => {
    dispatch(setSelectedTab({ page: "suggestedPlans", val }));
  };
  return (
    <div className="suggested-plans-component">
      <div className="suggested-plans-top-wrapper">
        <Typography variant={"body1"} showBold color={tokens.Text.General.Secondary}>
          Suggested Plans
        </Typography>
        {!isAboveProperty && (
          <Button onClick={redirectToSuggestedPlans} label="See All" variant="contained" size="Small" />
        )}
      </div>
      <div className="suggested-plans-bottom-wrapper">
        <Basictabs
          className="tabs-container"
          gap="16px"
          tabDetails={useTabDetails(metricsList)}
          alignItems="left"
          backgroundColor="transparent"
          defaultTab={currentTab}
          selectedTab={getSelectedTab}
          preventParentTab={true}
          onTabChangeFn={() => {
            dispatch(resetMetricsPlansIds());
            dispatch(setSuggestedPlanList());
          }}
        />
      </div>
    </div>
  );
}
